import * as React from "react";
import PropTypes from "prop-types";
import { CyMath } from "../../utilities/math";

export const percentageNumber = ({
 value,
 showSign,
 needCalculation = true,
 showPercentageSign = true,
}) => {
  if (value === null || value === undefined || value === "" ||  value === " " || isNaN(value)) return "--";

  let displayValue = value;
  if (typeof value === "string") {
    displayValue = parseFloat(value);
  }

  if (needCalculation) {
    displayValue = value * 100;
  }

  return `${showSign && displayValue > 0 ? "+" : ""}${CyMath.roundTwoDecimal(displayValue).toFixed(2)}${
    showPercentageSign ? "%" : ""
  }`;
};

const PercentageNumber = (props) => (
  <React.Fragment>{percentageNumber(props)}</React.Fragment>
);

PercentageNumber.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  showSign: PropTypes.bool,
  decimal: PropTypes.number,
  needCalculation: PropTypes.bool,
  showPercentageSign: PropTypes.bool,
};

PercentageNumber.defaultProps = {
  showSign: false,
  decimal: 2,
};

export default PercentageNumber;



// WEBPACK FOOTER //
// ./src/components/UI/PercentageNumber.jsx